module.exports = __webpack_public_path__ + "img/map-malawi.862b1d12.png";